import React from 'react';
import { Grid, Tooltip, Typography, useTheme } from '@mui/material';
import { SquaredBoxCenteredContent } from '../../../../style/common';
import { createRandomSeed, getSocialIcon, parseSocialName } from '../../../../utils/functions';
import Title from '../../Common/title';
import Column from '../../../Column';
import { colors } from '../../../../utils/palette';
import { SocialIconsType } from '../../../../dto/Interfaces/IIconProps';

export type SocialStatus = 'normal' | 'unknown';
export type ListOfSocialLinks = Partial<Record<SocialIconsType, string>>;

export interface SocialImagesProps {
  type: 'socialImages';
  socials: SocialIconsType[];
  max_elements?: number;
  title?: string;
  socialStatus?: SocialStatus[];
  listOfLinks?: ListOfSocialLinks | null;
}

const SocialImages: React.FC<SocialImagesProps> = ({ socials, max_elements, title, socialStatus, listOfLinks }) => {
  const theme = useTheme();
  const limit = max_elements !== undefined ? (max_elements > 0 ? max_elements : 1) : socials.length;
  const maxElementsArray = limit ? [...socials].splice(0, limit) : socials;

  return (
    <Column>
      <>{title && <Title value={title} />}</>
      <Grid container style={{ display: 'flex', gap: theme.spacing(1), paddingTop: 0 }}>
        {maxElementsArray.length > 0 ? (
          maxElementsArray
            .filter((so) => parseSocialName(so) !== 'empty')
            .map((social: SocialIconsType, index) => {
              const rndString = createRandomSeed();
              const bgColor = socialStatus && socialStatus[index] === 'unknown' ? theme.palette.grey[400] : theme.palette.primary.main;
              const parsedName = parseSocialName(social);
              const socialUrl = listOfLinks?.[parsedName];
              return (
                <Tooltip title={`${social.charAt(0).toUpperCase()}${social.slice(1)}`} arrow data-testid="icon-wrapper" key={rndString}>
                  <SquaredBoxCenteredContent style={{ backgroundColor: bgColor }} component="div">
                    {socialUrl ? (
                      <a href={socialUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'flex' }}>
                        {getSocialIcon(parsedName, bgColor)}
                      </a>
                    ) : (
                      getSocialIcon(parsedName, bgColor)
                    )}
                  </SquaredBoxCenteredContent>
                </Tooltip>
              );
            })
        ) : (
          <>-</>
        )}
        {limit > 0 && socials.length > limit && (
          <SquaredBoxCenteredContent
            style={{
              backgroundColor: colors.lightSecondary,
              color: theme.palette.text.secondary,
            }}
            component="div"
          >
            <Typography style={{ height: '20px', fontWeight: '600', fontSize: '14px' }}>+{socials.length - limit}</Typography>
          </SquaredBoxCenteredContent>
        )}
      </Grid>
    </Column>
  );
};

export default SocialImages;
